<ifb-card *ngIf="entries?.length && entries[0]">
  <mat-card appearance="raised">
    <mat-card-header class="card-header">
      <mat-card-title>Interest Rate Change History</mat-card-title>
    </mat-card-header>
    <mat-card-content class="layout padding-bottom-md">
      <ifb-account-interest-rate-change-history-item [entries]="entries">
      </ifb-account-interest-rate-change-history-item>
    </mat-card-content>
  </mat-card>
</ifb-card>
